import lozad from 'lozad/dist/lozad';

export default function observeIntersection() {
  const observer = lozad('.js-observer', {
    rootMargin: '0% 0% -33%',
  });
  observer.observe();
}
